import * as React from "react";
import Header from "./Header";
import CurrencyInput from './CurrencyInput'
import { connect } from "react-redux";
import { Choice } from "../../models/choice";
import { FormStep, Step } from "../../store/application/applicationState";
import {
    ApplicationAction,
   
    gotoStep,
    setDwelling
} from "../../store/application/applicationActions";
import ApplicationContent from "../applicationContent";
import ApplicationFooter from "../applicationFooter";

import {
    Button,
    FormGroup,
    Label,
    Input,
    CustomInput,
    Row,
    Col
} from "reactstrap";
import { trackEvent } from "../../util/gtm";
import { RootState } from "../../store";
import { MultipleChoiceForm } from "./MultipleChoiceForm";
import { DwellingAttribute } from "../../models/dwellingattribute";




type Props = ReturnType<typeof mapDispatchToProps> & ReturnType<typeof mapStateToProps>;

interface State {
    dwelling: string;
    rent: string;
    dirty: boolean;
    additionalText: string
}

class Dwelling extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props);
        this.state = {
            dwelling: "",
            rent: "",
            dirty: false,
            additionalText: ""
        }
    }

    clickedDwelling(val): void {
        this.setState({
            dwelling: val
        })
        console.log(val);
        switch (val) {
            case "Lejebolig":
                return this.setState({ additionalText: "Husleje" })
            case "Ejerlejlighed":
                return this.setState({ additionalText: "Ejerudgifter" })
            case "Andelsbolig":
                return this.setState({ additionalText: "Husleje" })
            case "Værelse/kollegie":
                return this.setState({ additionalText: "Husleje" })
            case "Bor hjemme":
                return this.setState({ additionalText: "Husleje" })
            case "Hus":
                return this.setState({ additionalText: "Ejerudgifter" })
            default:
        }
    }
    next(): void {
        this.setState({ dirty: true });
        const otherReasonValid = !DwellingAttribute.hasError(this.state.rent);

        if (otherReasonValid == true) {
            //all good.
            this.props.setDwelling(
                this.state.dwelling,
                this.state.rent,

            );
            trackEvent(
                "Boligform",
                "Bolig: " + this.state.dwelling + " udgifter: " + this.state.rent,
                "Boligform",
                "Bolig: " + this.state.dwelling + " udgifter: " + this.state.rent

            )
        }
    }
    nextWithoutRent(val): void {
        this.setState({
            dwelling: val
        });
        trackEvent(
            "Boligform",
            "Bolig: " + this.state.dwelling + " udgifter: Ingen" ,
            "Boligform",
            "Bolig: " + this.state.dwelling + " udgifter: Ingen" 

        )
    }
    resetDwelling(): void {
        this.setState({
            dwelling: ""
        })
    }


    private choices: Array<Choice<string>> = [
        new Choice<string>("Lejebolig", "Lejebolig", val => this.clickedDwelling(val)),
        new Choice<string>("Ejerlejlighed", "Ejerlejlighed", val => this.clickedDwelling(val)),
        new Choice<string>("Hus", "Hus", val => this.clickedDwelling(val)),
        new Choice<string>("Andelsbolig", "Andelsbolig", val => this.clickedDwelling(val)),
        new Choice<string>("Værelse/kollegie", "Værelse/kollegie", val => this.clickedDwelling(val)),
        new Choice<string>("Bor hjemme", "Bor hjemme", val => this.clickedDwelling(val))

    ];

    render() {
        var params = window.location.search.toString();
        var regex = /((&|\?)step=)[0-9]{1,2}/gi;
        if (params != "") {
            params = params.replace(regex, "$1" + "9");
        }
        var stepQuery = window.location.protocol + "//" + window.location.host + window.location.pathname + params;
        window.history.pushState({ path: stepQuery }, '', stepQuery)
        console.log(this.state.dwelling);
        return (
            <div>
                <Header formStep={FormStep.Other} step={Step.Dwelling} />
                <ApplicationContent>
                    {this.state.dwelling.length == 0 && <MultipleChoiceForm
                        title="Boligform"
                        paragraph=""
                        choices={this.choices}
                        collumns={3} 
                    />}



                    {this.state.dwelling.length >= 1 && <FormGroup id="OtherloanInput">
                        <div className="row"><div className="text-center col"><h3 className="text-uppercase">{this.state.additionalText}</h3></div></div>
                        <div className="DwellingForm">

                            <Label for="rent" className="text-uppercase font-weight-bold">
                                Månedlige {this.state.additionalText} ekskl. el, vand og varme
                            </Label>
                          

                        </div>
                        <CurrencyInput
                            maskOptions
                            className={
                                this.state.dirty && DwellingAttribute.hasError(this.state.rent)
                                    ? "is-invalid form-control"
                                    : "form-control"

                            }
                            type="text"
                            id="rent"
                            name="rent"
                            placeholder="1.234 kr."
                            value={this.state.rent}

                            onChange={event => this.setState({ rent: event.target.value })}
                        />

                        {this.state.dirty &&

                            DwellingAttribute.hasError(this.state.rent) && (
                                <div className="invalid-feedback">
                                    {DwellingAttribute.getErrorMessage()}
                                </div>
                            )}
                    </FormGroup>}
                </ApplicationContent>


                <ApplicationFooter>
                    <Row className="mt-2">
                        <Col className="col-12 text-right">
                            {this.state.dwelling.length > 0 &&
                                <Button className="back" onClick={() => this.resetDwelling()}>
                                    Tilbage
                            </Button>
                            }

                            {this.state.dwelling.length == 0 &&
                                <Button className="back" onClick={() => this.props.previous()}>
                                    Tilbage
                            </Button>
                            }

                            {this.state.dwelling.length > 0 &&
                                <Button className="next" onClick={() => {
                                    this.next();

                                }}>
                                    Næste
                        </Button>
                            }
                        </Col>
                    </Row>
                </ApplicationFooter>
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch: (action: ApplicationAction) => void) => ({
    previous: () => dispatch(gotoStep(Step.Coappliant)),
    //next: () => dispatch(gotoStep(Step.Coappliant)),

    setDwelling: (dwelling: string, rent: string) => {
        dispatch(setDwelling(dwelling, rent));
    

    }

});
const mapStateToProps = (state: RootState) => ({
    dwelling: state.applicationState.data.dwelling
});
export default connect(mapStateToProps, mapDispatchToProps)(Dwelling);
